module.exports = __webpack_public_path__ + "r-v3/img/sticker_11.920bc716.svg";